import React, { useEffect, useState } from 'react';
import axios from 'axios';
import CalenderLinks from '../../../components/CalanderLinks/CalanderLinks';
import Footer from '../../../components/Footer/Footer';
import InnerNav from '../../../components/InnerNav/InnerNav';
import './Chaitra.scss';

const Chaitra = () => {
  const currentYear = new Date().getFullYear();
  const [year, setYear] = useState(currentYear);
  const [navratriData, setNavratriData] = useState([]);
  const [loading, setLoading] = useState(false);


  // temporary values (for input fields)
const [tempYear, setTempYear] = useState(currentYear);

  // ---- New: modal states ----
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

const eventSignificanceMap = {
  "Ghatasthapana": "Marks the beginning of Navratri with the installation of a sacred pot (kalash).",
  "Shailputri Puja": "Worship of Goddess Shailputri, the first form of Durga symbolizing nature and purity.",
  "Chandra Darshana": "First sighting of the moon after Amavasya, considered auspicious.",
  "Sindhara Dooj": "A tradition where women receive gifts from their parents.",
  "Brahmacharini Puja": "Worship of the second form of Durga, symbolizing austerity and penance.",
  "Gauri Puja": "Dedicated to Goddess Parvati (Gauri), representing purity and fertility.",
  "Saubhagya Teej": "A festival for marital happiness and well-being.",
  "Chandraghanta Puja": "Worship of the third form of Durga, known for bravery and protection.",
  "Kushmanda Puja": "Worship of the fourth form of Durga who is believed to have created the universe.",
  "Vinayaka Chaturthi": "A day to worship Lord Ganesha for wisdom and success.",
  "Naag Puja": "Devotion to serpent gods for protection and good fortune.",
  "Lakshmi Panchami": "Worship of Goddess Lakshmi for wealth and prosperity.",
  "Skandamata Puja": "Fifth form of Durga, mother of Skanda (Kartikeya), symbol of motherly love.",
  "Skanda Sashti": "Celebration of Lord Skanda’s (Kartikeya) victory over evil.",
  "Yamuna Chhath": "Worship of River Yamuna, believed to cleanse sins.",
  "Katyayani Puja": "Sixth form of Durga, a warrior goddess born to sage Katyayana.",
  "Maha Saptami": "Important day symbolizing the awakening of Goddess Durga.",
  "Kalaratri Puja": "Worship of the fiercest form of Durga, remover of darkness and ignorance.",
  "Durga Ashtami": "One of the most significant days, marking Durga’s battle against Mahishasura.",
  "Mahagauri Puja": "Eighth form of Durga, signifying calmness and purity.",
  "Annapurna Ashtami": "Devotion to the goddess of nourishment and food.",
  "Sandhi Puja": "Performed during the transition between Ashtami and Navami, considered highly powerful.",
  "Rama Navami": "Celebration of the birth of Lord Rama, an incarnation of Vishnu.",
  "Navratri Parana": "Formal conclusion of Navratri, with special prayers and rituals."
};

  // ---- New: long popups for modal ----
  const popups = {
    "Ghatasthapana": "Ghatasthapana is the ceremonial initiation of Chaitra Navratri, where a sacred kalash (metal or clay pot) is installed in a clean, decorated area of the home or temple. The kalash is filled with holy water, coins, betel leaves, and mango leaves, symbolizing the presence of the Goddess. Devotees recite prayers and mantras over nine days, seeking prosperity, health, spiritual energy, and harmony within the household. The ritual serves as a reminder to start new ventures with devotion and focus.",
    "Shailputri Puja": "Shailputri Puja involves worshiping Goddess Shailputri, the first form of Durga, representing purity, innocence, and nature's nurturing energy. Devotees offer flowers, fruits, and prayers while meditating on her divine qualities. This day encourages self-discipline, harmony with nature, and strengthening one's spiritual connection with the divine feminine power.",
    "Chandra Darshana": "Chandra Darshana is the auspicious first sighting of the moon after Amavasya. Observing the moon on this day is believed to bring peace, mental clarity, and spiritual insight. Devotees offer prayers to seek divine blessings for prosperity, family well-being, and protection from negative energies.",
    "Sindhara Dooj": "Sindhara Dooj is a traditional day when married women receive gifts, blessings, and tokens of love from their parents. The ritual symbolizes respect for family ties, appreciation of elders, and acknowledgment of familial love and care. It is also a time for women to pray for marital happiness and the well-being of their families.",
    "Brahmacharini Puja": "Brahmacharini Puja honors the second form of Goddess Durga, symbolizing austerity, penance, and steadfast devotion. Devotees often observe fasts, chant mantras, and meditate on her qualities to cultivate patience, discipline, and spiritual growth. Worshiping Brahmacharini is believed to bestow wisdom, endurance, and inner strength.",
    "Gauri Puja": "Gauri Puja is dedicated to Goddess Parvati, also called Gauri, symbolizing purity, fertility, and devotion. Women perform rituals for marital bliss, spiritual enrichment, and family prosperity. The day encourages reflection on personal virtues, moral conduct, and cultivating a nurturing, loving spirit within the household.",
    "Saubhagya Teej": "Saubhagya Teej celebrates marital happiness, fertility, and well-being. Women observe fasts, offer prayers, and engage in community celebrations. Devotees seek blessings for their spouses' health, longevity, and harmony in married life. The festival is a vibrant display of devotion, cultural traditions, and collective joy.",
    "Chandraghanta Puja": "Chandraghanta Puja worships the third form of Goddess Durga, who represents bravery and protection. Devotees recite mantras, light lamps, and meditate on her energy to overcome fear, negativity, and obstacles in life. This puja instills courage, focus, and spiritual resilience.",
    "Kushmanda Puja": "Kushmanda Puja is dedicated to the fourth form of Goddess Durga, believed to have created the universe. Devotees offer prayers, fruits, sweets, and flowers while chanting hymns that glorify her cosmic energy. Observing this puja is believed to bring vitality, prosperity, and spiritual awakening.",
    "Vinayaka Chaturthi": "Vinayaka Chaturthi honors Lord Ganesha, the remover of obstacles and bestower of wisdom. Devotees place clay idols, offer sweets like modaks, and chant mantras to invite his blessings for success in personal, academic, and professional endeavors.",
    "Naag Puja": "Naag Puja involves devotion to serpent deities for protection, fertility, and good fortune. Devotees offer milk, flowers, and prayers to holy snakes, believing in their divine energy to remove obstacles, safeguard homes, and bring prosperity.",
    "Lakshmi Panchami": "Lakshmi Panchami worships Goddess Lakshmi for wealth, abundance, and prosperity. Special rituals, offerings, and prayers are performed to invoke her blessings for financial stability, spiritual enrichment, and overall well-being.",
    "Skandamata Puja": "Skandamata Puja honors the fifth form of Goddess Durga, mother of Lord Skanda. Devotees offer prayers for maternal love, protection, and wisdom. The puja highlights the virtues of care, patience, and nurturing energy in family life.",
    "Skanda Sashti": "Skanda Sashti celebrates Lord Skanda’s victory over demons, symbolizing the triumph of righteousness. Devotees fast, offer prayers, and recount legends of bravery, courage, and moral integrity, inspiring strength and devotion.",
    "Yamuna Chhath": "Yamuna Chhath involves worshiping the River Yamuna, believed to purify sins and negative karma. Devotees offer water, flowers, and prayers to honor her life-giving properties, seeking spiritual cleansing and divine grace.",
    "Katyayani Puja": "Katyayani Puja worships the sixth form of Durga, a warrior goddess born to sage Katyayana. Devotees perform rituals to invoke courage, wisdom, and protection from evil. The puja emphasizes moral strength, discipline, and righteous action.",
    "Maha Saptami": "Maha Saptami symbolizes the awakening of Goddess Durga, marking the start of major rituals during Navratri. Devotees offer prayers, perform fasts, and participate in community ceremonies to invite divine blessings for protection and prosperity.",
    "Kalaratri Puja": "Kalaratri Puja honors the fiercest form of Goddess Durga, who removes darkness, fear, and ignorance. Devotees chant hymns, offer prayers, and meditate to overcome personal obstacles and gain inner courage.",
    "Durga Ashtami": "Durga Ashtami marks the day of Goddess Durga’s battle against Mahishasura. Devotees perform Sandhi Puja, Kumari Puja, and extensive rituals to invoke her power, protection, and blessings for health, wealth, and spiritual growth.",
    "Mahagauri Puja": "Mahagauri Puja venerates the eighth form of Goddess Durga, representing calmness, purity, and serenity. Devotees pray for harmony, righteousness, and mental clarity, while offering sweets and flowers as part of the rituals.",
    "Annapurna Ashtami": "Annapurna Ashtami is dedicated to the goddess of nourishment. Devotees offer food, prayers, and perform charitable acts to honor her divine energy and ensure the well-being of their families and communities.",
    "Sandhi Puja": "Sandhi Puja is performed at the precise juncture between Ashtami and Navami tithis. Devotees offer 108 lamps, chant hymns, and conduct elaborate rituals to harness maximum divine power, removing obstacles and ensuring blessings for prosperity and protection.",
    "Rama Navami": "Rama Navami celebrates the birth of Lord Rama, an incarnation of Vishnu. Devotees observe fasts, perform prayers, and recount sacred stories of virtue, courage, and devotion, inspiring moral and spiritual growth.",
    "Navratri Parana": "Navratri Parana marks the formal conclusion of Navratri. Special prayers, rituals, and offerings are performed to thank the Goddess for her blessings and ensure continued protection, prosperity, and spiritual guidance."
  };

  useEffect(() => {
    const fetchChaitraNavratri = async () => {
      setLoading(true);
      try {
        const response = await axios.get(
          `https://core-c343.onrender.com/api/Chaitra-navratri?year=${year}`
        );
        const data = response.data.ChaitriNavratriDates || [];
        setNavratriData(data);
      } catch (error) {
        console.error('Error fetching Chaitra Navratri data:', error);
        setNavratriData([]); // Clear data on error
      }
      setLoading(false);
    };

    fetchChaitraNavratri();
  }, [year]);


    const handleSubmit = () => {
  setYear(tempYear);
};

  // ---- New: modal functions ----
  const handleEventClick = (eventName) => {
    setSelectedEvent(eventName);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setSelectedEvent(null);
    setIsModalOpen(false);
  };


  return (
    <div className="Chaitra-container">
      <InnerNav />
      <div className="Chaitra-content">
        <div className="year-selector">
        <label htmlFor="year">Select Year: </label>
        <input
          id="year"
          type="number"
          min="1900"
          max="2100"
          value={tempYear}
          onChange={(e) => setTempYear(Number(e.target.value))}
        />
        <button className="submit" onClick={handleSubmit}>Submit</button>
      </div>

        <h1 className="s-heading">{year} Chaitra Navaratri</h1>

        {loading ? (
          <p>Loading...</p>
        ) : navratriData.length === 0 ? (
          <p className="no-data-msg">❌ No Chaitra Navratri data available for {year}.</p>
        ) : (
          navratriData.map((item, index) => (
            <div className="Chaitra-card" key={index}>
              <div className="card-header">Chaitra Navaratri Day {item.day}</div>

              <div className="card-body">
                <div className="s-right-section">
                  <div className="s-badge">{item.day}</div>
                  <img
                    src="https://img.etimg.com/photo/msid-119987877,imgsize-101934/ChaitraNavratri2025.jpg"
                    alt="Goddess"
                  />
                </div>

                <div className="s-details">
                  <div className="s-tithi">{item.tithi}</div>

                  <ul className="s-festivals">
                    {item.events.map((event, idx) => (
                      <li key={idx} className="tooltip-wrapper">
                          <span
                          className="event-text"
                          onClick={() => handleEventClick(event)}
                          style={{ cursor: 'pointer', textDecoration: 'underline #dd1919ff', color: '#e11111ff' }}
                        >
                          Event: {event}
                        </span>

                        {eventSignificanceMap[event] && (
                          <span className="tooltip">{eventSignificanceMap[event]}</span>
                        )}
                      </li>
                    ))}
                  </ul>



                  {item.sandhi_puja_timings && (
                    <div className="s-timings">
                      Sandhi Puja: {item.sandhi_puja_timings.start} - {item.sandhi_puja_timings.end}
                    </div>
                  )}
                </div>

                <div className="date-box">
                  <div className="date">
                    {new Date(item.date).getDate()}
                    <sup>th</sup>
                  </div>
                  <div className="month-year">
                    {new Date(item.date).toLocaleString('default', {
                      month: 'long',
                      year: 'numeric',
                    })}
                  </div>
                  <div className="weekday">{item.weekday}</div>
                </div>
              </div>
            </div>
          ))
        )}

        <CalenderLinks />
      </div>
      <Footer />

        {isModalOpen && selectedEvent && (
        <div className="modal-overlay" onClick={handleCloseModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <h2>{selectedEvent}</h2>
            <p>{popups[selectedEvent]}</p>
            <button className="close-btn" onClick={handleCloseModal}>Close</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Chaitra;
